import commonGenerator from './common-generator';

// eslint-disable-next-line
export const generateNote = commonGenerator(entity => entity);
